<template>
  <div class="full-view">
    <dsf-home v-if="pageSuffix == 'index'" :menu-list="menuList">
      <dsf-default-home-header
        slot="header"
        :title="title"
        :dropdown-config="dropdownConfig"
        @dropdown-click="dropdownClick"
      >
        <template #title>
          <div class="platform-title">
            <div class="site-name">
              <div class="title" v-if="title && title.length" >{{ title }}</div>
              <div class="mi" v-if="smTitle">
                <img :src="miPng" class="mi-png">{{ smTitle }}
              </div>
            </div>
          </div>
        </template>
      </dsf-default-home-header>
      <template slot="left">
        <dsf-sc-home-aside-select v-if="menuList.length" />
        <dsf-default-home-aside-menu position="left" />
      </template>
      <router-view fit></router-view>
      <dsf-personalization
        :show.sync="personalizationShow"
      ></dsf-personalization>
    </dsf-home>
    <dsf-home v-else-if="pageSuffix == 'index1'" :menu-list="menuList">
      <dsf-template1-home-header
        slot="header"
        :dropdown-config="dropdownConfig"
        last-level-click
        @dropdown-click="dropdownClick"
      />
      <dsf-default-home-breadcrumb slot="breadcrumb" />
      <dsf-default-home-footer
        slot="footer"
        text="技术支持：上海梦创双杨数据科技股份有限公司"
      />
      <router-view fit></router-view>
      <dsf-personalization
        :show.sync="personalizationShow"
      ></dsf-personalization>
    </dsf-home>
    <dsf-home
      class="dsf-normal-user-home dsf-specially-home"
      v-else-if="pageSuffix == 'normal' || pageSuffix == 'specially' || pageSuffix == 'lite'"
      :menu-list="menuList" 
      :now="pageSuffix"
    >
      <Head slot="header" @loginOut="loginOut" :pageSuffix="pageSuffix"></Head>
      <Menu v-if="pageSuffix == 'specially'" slot="left" position="left" />
      <router-view fit></router-view>
    </dsf-home>
    <router-view v-else class="page-head-font-fixed"></router-view>
  </div>
</template>

<script>
import Head from "../components/head/Head.vue";
import Menu from "../components/menu/Menu.vue";
import DsfScHomeAsideSelect from "../components/homeAsideSelect";

export default {
  name: "Home",
  components: {
    Head,
    Menu,
    DsfScHomeAsideSelect,
  },
  props: {
    pageSuffix: {
      type: String,
      default: "else",
    },
  },
  data() {
    let dropdownConfig = [{ name: "切换组", key: "groupChange" }]
    if (dsf.config.setting_public_hidden_update_password == 1) {
      dropdownConfig.push({ name: "修改密码", key: "alterPwd" })
    }
    dropdownConfig.push({ name: "返回工作台", key: "backWorkbench" })
    dropdownConfig.push({ name: "退出", key: "loginOut", handler: "loginOut" })
    return {
      title: "",
      personalizationShow: false,
      /**
       * **用户头像下的菜单** <br/>
       *  **name**: {String} _必须_ 显示文字 <br/>
       *  **key**: {String | Number} _非必须_ 菜单标识<br/>
       *  -----以下属性任意存在一个------ <br/>
       *  **url**: {String} _非必须_ 如果存在则跳转页面 <br/>
       *  **openUrl**: {String} _非必须_ 如果存在则新开页面 <br/>
       *  **handler**: {String} _非必须_ 如果存在则调用对应方法
       */
      dropdownConfig: dropdownConfig,
      menuList: [],
      smTitle: dsf.config.setting_platform_attach_logo_title,
      miPng: dsf.config.setting_platform_attach_logo_image || require("../../assets/styles/img/mi.png"),
    };
  },
  created() {
    if (!["else","specially","normal","lite"].includes(this.pageSuffix)) {
      getMenuTree.call(this);
    }
  },
  methods: {
    // 用户头像下的菜单点击
    dropdownClick(item) {
      if (item.url) {
        window.location.href = item.url;
      } else if (item.openUrl) {
        window.open(item.openUrl);
      } else if (item.handler) {
        this[item.handler] && this[item.handler](item);
      } else {
        // 其他情况自行处理
        if (item.key == "backWorkbench") {
          window.open(dsf.config.setting_public_back_workbench_url);
        }
      }
    },
    personalizationSetting() {
      this.personalizationShow = true;
    },
    // 自带方法：退出登录
    loginOut() {
      dsf.layer
        .confirm("您确定要退出吗?")
        .then(() => {
          // 应后端要求，退出登录cookies由后端清除，若接口异常直接提示报错信息
          this.$webAPI
            .loginOut()
            .then(({ success, message }) => {
              if (success) {
                dsf.storage.session.clear();
                location.replace(dsf.config.setting_public_pc_login_page);
              } else {
                dsf.layer.message(message, false);
              }
            })
            .catch((err) => {
              console.error(err);
              dsf.layer.message("退出失败", false);
            });
        })
        .catch(() => {});
    },
  },
  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler(route) {
        this.title =
          dsf.url.parse(location.href).searchQuery.title ||
          dsf.config.setting_public_logo_title;
      },
    },
  },
};

/**
 * 请求菜单数据
 */
function getMenuTree() {
  this.$http
    .get(dsf.config.setting_public_home_menu_src)
    .done(({ success, data }) => {
      if (success) {
        this.menuList = data;
        dsf.storage.session.set("homeMenu", data);
      }
    })
    .error((error) => {
      dsf.httpError(error);
      // dsf.layer.message(message, false);
    });
}
</script>
